import { createProject } from './createProject'
import { DUPLICATED_PROJECT_NAME_POSTFIX } from '~/constant'
import * as API from '~/ServerAPI'

export const duplicateProject = projectId => async dispatch => {
  const duplicatingProject = (await API.getProject(projectId))
  const createTime = Date.now()
  const { name, data, thumbnail } = duplicatingProject
  const duplicateName = name + DUPLICATED_PROJECT_NAME_POSTFIX
  const { id } = await dispatch(createProject(
    data,
    duplicateName,
    thumbnail,
    createTime,
    { isInitialRenaming: true, updateProjectFileRefCount: true }
  ))

  return id
}
